// Reducers
import auth from './reducers/auth';
import interviews from './reducers/interviews';
import notifications from './reducers/notifications';
import projectDetails from './reducers/profile/projectDetails';
import educationDetails from './reducers/profile/educationDetails';
import employmentDetails from './reducers/profile/employmentDetails';
import resumeDetails from './reducers/profile/resumeDetails';
import jobs from './reducers/jobs';
import applyJobs from './reducers/applyJobs';
import job from './reducers/job';
import resumeFetchDetails from './reducers/resumeFetchDetails';

// Utility Packages
import { combineReducers } from 'redux';
import profileScore from './reducers/profile/profileScore';

/* *********************** */
/* ***** Imports End ***** */
/* *********************** */

export default combineReducers({
  auth,
  notifications,
  interviews,
  profileScore,
  projectDetails,
  educationDetails,
  employmentDetails,
  resumeDetails,
  jobs,
  applyJobs,
  job,
  resumeFetchDetails,
});
